module.exports = __webpack_public_path__ + "static/img/template-img2.dcb3536b.png";